/**
 * 系统管理  角色管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>角色管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form  class="user-search">
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加角色</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column  prop="role_name" label="角色名称" width="300">
      </el-table-column>
      <el-table-column sortable prop="display_name" label="角色说明" width="300">
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="300">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteRole(scope.$index, scope.row)">删除</el-button>
          <el-button size="mini" type="success" @click="menuAccess(scope.$index, scope.row)">菜单权限</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeEditDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="角色名称" prop="role_name">
          <el-input size="small" v-model="editForm.role_name" auto-complete="off" placeholder="请输入角色名称"></el-input>
        </el-form-item>
        <el-form-item label="角色说明" prop="display_name">
          <el-input size="small" v-model="editForm.display_name" auto-complete="off" placeholder="请输入角色说明"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeEditDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>

    <!-- 编辑界面 -->

    <!-- 菜单权限 -->
    <el-dialog title="菜单权限" :visible.sync="menuAccessshow" width="30%" @click='closeDialog("perm")'>
      <el-tree
        style="max-width: 600px"
        :data="treeData"
        show-checkbox
        node-key="id"
        ref="tree"
        :default-checked-keys="checkedKeys"
        :props="defaultProps"
      />
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("perm")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="menuPermSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getMenus,
  getRole,
  addRole,
  deleteRole,
  updateRole,
  getTreeMenu,
  menuPermSave,
  getRolePermission
  // RoleRightTree,
  // RoleRightSave
} from '../../api/role'
export default {
  data() {
    return {
       defaultProps :{
        children: 'children',
        label: 'display_name',
      },
      checkedKeys:[],
      treeData : [],
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      menuAccessshow: false, //控制数据权限显示与隐藏
      title: '添加',
      editForm: {
        name:'',
        role_name: '',
        display_name: '',
        token: localStorage.getItem('logintoken')
      },
      rules: {
        role_name: [
          { required: true, message: '请输入角色名称', trigger: 'blur' }
        ]
      },
      formInline: {
        token: localStorage.getItem('logintoken')
      },
      // 删除
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 数据权限
      RoleRight: [],
      RoleRightProps: {
        children: 'children',
        label: 'name'
      },
      // 选中
      checkmenu: [],
      //参数role
      saveroleId: '',

    }
  },

  /**
   * 数据发生改变
   */

  watch: {},

  /**
   * 创建完毕
   */

  created() {
    this.getTreeMenu()
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */

  methods: {
    getdata() {
      this.loading = true
      getRole().then(res => {
          this.loading = false
          this.listData = res.data
      })
    },
    getTreeMenu() {
      this.loading = true
      getTreeMenu().then(res => {
          this.loading = false
          this.treeData = res
      })
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true

      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.role_name = row.role_name
        this.editForm.name = this.editForm.role_name
        this.editForm.display_name = row.display_name
        this.editForm.id = row.role_id
        this.editForm.guard_name = row.guard_name
        this.editForm.department_id = row.departments[0].department_id

      } else {
        this.title = '添加'
        this.editForm =  {
          name: '',
          role_name:'',
          display_name: '',
          guard_name:'admin'
        }
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          this.editForm.name = this.editForm.role_name
          if(this.editForm.id){

            updateRole(this.editForm.id, this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false

                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
          }else{
            addRole(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false

                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '添加成功！'
                })

            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('添加失败，请稍后再试！')
            })
          }

        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteRole(index, row) {
      this.$confirm('此操作将删除该菜单及子菜单, 是否继续?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteRole(row.role_id)
            .then(res => {
              if (res.code == 0 ) {
                this.$message({
                  type: 'success',
                  message: '已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeEditDialog() {
      this.editFormVisible = false
    },
    // 数据权限
    menuAccess: function(index, row) {
      this.menuAccessshow = true
      this.saveroleId = row.role_id
      this.checkedKeys=[]
      //获取当前角色的菜单权限
      getRolePermission({role_id:row.role_id})
        .then(res => {
          if (res.code == 0) {
            // this.$message({
            //   type: 'success',
            //   message: '获取权限成功'
            // })
            this.$refs.tree.setCheckedKeys(res.data)
          } else {
            this.$message({
              type: 'info',
              message: res.data.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('获取权限失败，请稍后再试！')
        })
    },
    // 选中菜单
    changemenu(arr) {
      let change = []
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].checked) {
          change.push(arr[i].id)
        }
      }
      this.checkmenu = change
    },
    // 菜单权限-保存
    menuPermSave() {
      let parm = {
        roleId: this.saveroleId,
        permissions: ''
      }
      let node = this.$refs.tree.getCheckedNodes()
      let permissions = []
      if (node.length != 0) {
        for (let i = 0; i < node.length; i++) {
          permissions.push(node[i].id)
        }
        // parm.moduleIds = JSON.stringify(moduleIds)
        parm.permissions = permissions.join(",")
      }
      menuPermSave(parm.roleId,parm)
        .then(res => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '权限保存成功'
            })
            this.menuAccessshow = false
            this.getdata(this.formInline)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('权限保存失败，请稍后再试！')
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      } else if (dialog == 'perm') {
        this.menuAccessshow = false
      }
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/views/system/Role.vue